export const menuItems = [
         {
           name: '',
           label: 'Home'
         },
         { name: 'about', label: 'About' },
         { name: 'services', label: 'Services' },
         { name: 'contact', label: 'Contact Us' }
       ];
